import React, { useState, useEffect } from 'react';
import './App.css';
import Home from './components/Home';

const APP_BOOT_STORAGE_KEY = 'geomatixs_app_splash_shown';

function App() {
  const [loading, setLoading] = useState(() => {
    try {
      return sessionStorage.getItem(APP_BOOT_STORAGE_KEY) !== '1';
    } catch {
      return true;
    }
  });
  const [showScrollUp, setShowScrollUp] = useState(false);

  useEffect(() => {
    let timer;
    if (loading) {
      timer = setTimeout(() => {
        setLoading(false);
        try {
          sessionStorage.setItem(APP_BOOT_STORAGE_KEY, '1');
        } catch {
          /* ignore private mode / quota */
        }
      }, 3000);
    }

    const handleScroll = () => {
      setShowScrollUp(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      if (timer) clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-particles"></div>
        <img src={`${process.env.PUBLIC_URL}/geologo-new.png`} alt="Geomatixs Group Corporation" className="loading-logo" />
        <div className="loading-text">Geomatixs Group Corporation</div>
        <div className="loading-progress">
          <div className="loading-progress-bar"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {/* Scroll Progress Bar */}
      <div className="scroll-progress-container">
        <svg className="scroll-progress-svg" width="48" height="48" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="20" stroke="#FFD300" strokeWidth="5" fill="none" opacity="0.18"/>
          <circle className="scroll-progress-bar" cx="24" cy="24" r="20" stroke="#FFD300" strokeWidth="5" fill="none" strokeLinecap="round" strokeDasharray="125.6" strokeDashoffset="125.6"/>
        </svg>
      </div>

      {/* Main Content */}
      <main>
        <Home />
      </main>

      {/* Scroll Up Button */}
      {showScrollUp && (
        <button
          className="scroll-up-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="28" height="28">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </button>
      )}
    </div>
  );
}

export default App;
